import * as React from 'react';

import {Icon} from '@spaced-out/ui-design-system/lib/components/Icon';
import {Tooltip} from '@spaced-out/ui-design-system/lib/components/Tooltip';

import useLabelTranslation from 'src/hooks/useLabelTranslation';

import {getWidgetLimitTooltipBody} from 'src/components/analytics-genesis/byod/utils/widget-limit-tooltip';

import {useCanvasContext} from './canvas-context';
import css from './dashboard-builder-canvas-layout.css';


export type AddRowDividerProps = {
  afterIndex: number;
  /** Canvas-owned: adds a section AND opens it for inline edit. */
  onAddSection: (afterIndex: number) => void;
};

export const AddRowDivider = React.memo(
  ({afterIndex, onAddSection}: AddRowDividerProps) => {
    const {t} = useLabelTranslation();
    const {onAddWidget, isAtWidgetLimit} = useCanvasContext();

    const addReportTooltipBody = isAtWidgetLimit
      ? getWidgetLimitTooltipBody(t)
      : t('Add_Report', 'Add Report');

    return (
      <div className={css.rowDivider}>
        <div className={css.rowDividerInner}>
          <div className={css.rowDividerLine} />
          <div className={css.rowDividerActions}>
            <Tooltip body={t('Add_Section', 'Add Section')} placement="top">
              <button
                type="button"
                className={css.rowDividerBtn}
                onClick={() => onAddSection(afterIndex)}
                aria-label={t('Add_Section', 'Add Section')}
              >
                <Icon
                  name="square-a"
                  type="solid"
                  size="medium"
                  color="clickable"
                />
              </button>
            </Tooltip>
            <Tooltip body={addReportTooltipBody} placement="top">
              {/* Span wrapper so the Tooltip's hover listeners attach to a
                  non-disabled element. Browsers (notably WebKit) suppress
                  pointer events on `<button disabled>`. */}
              <span style={{display: 'inline-flex'}}>
                <button
                  type="button"
                  className={css.rowDividerBtn}
                  onClick={() => onAddWidget?.({afterIndex})}
                  disabled={isAtWidgetLimit}
                  aria-label={t('Add_Report', 'Add Report')}
                >
                  <Icon
                    name="square-poll-vertical"
                    type="solid"
                    size="medium"
                    color={isAtWidgetLimit ? 'disabled' : 'clickable'}
                  />
                </button>
              </span>
            </Tooltip>
          </div>
        </div>
      </div>
    );
  },
);
